// src/components/CartItem.jsx
import React from "react";
import { X, Plus, Minus } from "lucide-react";
import { useCart } from "../../context/CartContext";

const CartItem = ({ item, onRemove, isSubmitting, type }) => {
  const { 
    updateCatalogItemQuantity,
    getCatalogItemQuantity 
  } = useCart();

  const quantity = type === "catalog" ? getCatalogItemQuantity(item.id) : 1;

  const renderPreview = () => {
    if (type === "photo") {
      return item.type === "video" ? (
        <video src={item.url} muted />
      ) : (
        <img src={item.url} alt={item.name} />
      );
    } else {
      // Handle both image (single) and images (array) properties
      const imageSrc = item.image || (item.images && item.images[0]) || '';
      return <img src={imageSrc} alt={item.title} />;
    }
  };

  const handleQuantityChange = (newQuantity) => {
    if (type === "catalog") {
      if (newQuantity <= 0) {
        onRemove();
      } else {
        updateCatalogItemQuantity(item.id, newQuantity);
      }
    }
  };

  const handleIncrement = () => {
    if (type === "catalog") {
      handleQuantityChange(quantity + 1);
    }
  };

  const handleDecrement = () => {
    if (type === "catalog") {
      handleQuantityChange(quantity - 1);
    }
  };

  const renderDetails = () => {
    if (type === "photo") {
      return (
        <div className="item-details">
          <p className="item-price">
            {Number(item.price) === 0
              ? "Free"
              : `$${(Number(item.price) || 10).toFixed(2)}`}
          </p>
        </div>
      );
    } else {
      return (
        <div className="item-details">
          <h4>{item.title}</h4>
          <div className="item-price-container">
            <p
              className={`item-price ${
                item.title.includes("Pick 5") ? "strikethrough" : ""
              }`}
            >
              ${item.price}
            </p>
            {quantity > 1 && (
              <p className="item-subtotal">
                ${(Number(item.price) * quantity).toFixed(2)}
              </p>
            )}
          </div>
          <div className="quantity-controls">
            <button
              className="quantity-btn"
              onClick={handleDecrement}
              disabled={isSubmitting}
              title="Decrease quantity"
            >
              <Minus size={16} />
            </button>
            <span className="quantity-display">{quantity}</span>
            <button
              className="quantity-btn"
              onClick={handleIncrement}
              disabled={isSubmitting}
              title="Increase quantity"
            >
              <Plus size={16} />
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="cart-item">
      <div className="item-preview">
        {renderPreview()}
      </div>
      {renderDetails()}
      <button
        className="remove-item-btn"
        onClick={onRemove}
        title="Remove item"
        disabled={isSubmitting}
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default CartItem;
